import axios from "axios";
import { UserConfig } from "@/api/users";

export enum Role {
  ADMIN = "ADMIN",
  USER = "USER",
  TERMIN_API = "TERMIN_API",
  TERMIN_USER = "TERMIN_USER",
  PROJECT_MANAGER = "PROJECT_MANAGER",
}

export enum Permission {
  READ_FLAME = "READ_FLAME",
  MODIFY_FLAME = "MODIFY_FLAME",
  DELETE_FLAME = "DELETE_FLAME",
  CREATE_FLAME = "CREATE_FLAME",
  READ_PROJECT = "READ_PROJECT",
  MODIFY_PROJECT = "MODIFY_PROJECT",
  DELETE_PROJECT = "DELETE_PROJECT",
  CREATE_PROJECT = "CREATE_PROJECT",
  PROXY_FLAME = "PROXY_FLAME",
  PROXY_PROJECT = "PROXY_PROJECT",
  READ_TASKBOARD = "READ_TASKBOARD",
  MODIFY_TASKBOARD = "MODIFY_TASKBOARD",
  DELETE_TASKBOARD = "DELETE_TASKBOARD",
  CREATE_TASKBOARD = "CREATE_TASKBOARD",
  READ_USER = "READ_USER",
  MODIFY_USER = "MODIFY_USER",
  DELETE_USER = "DELETE_USER",
  READ_TODO = "READ_TODO",
  MODIFY_TODO = "MODIFY_TODO",
  DELETE_TODO = "DELETE_TODO",
  CREATE_TODO = "CREATE_TODO",
  READ_ENCOUNTER = "READ_ENCOUNTER",
  MODIFY_ENCOUNTER = "MODIFY_ENCOUNTER",
  DELETE_ENCOUNTER = "DELETE_ENCOUNTER",
  CREATE_ENCOUNTER = "CREATE_ENCOUNTER",
  GENERAL_ADMIN_FUNCTIONS = "GENERAL_ADMIN_FUNCTIONS",
  ADMIN_PROJECT = "ADMIN_PROJECT",
  READ_CONTACT  = "READ_CONTACT",
  MODIFY_CONTACT = "MODIFY_CONTACT",
  DELETE_CONTACT = "DELETE_CONTACT",
  CREATE_CONTACT = "CREATE_CONTACT",
  READ_CONTACT_DOCUMENTS = "READ_CONTACT_DOCUMENTS",
  UPLOAD_CONTACT_DOCUMENTS = "UPLOAD_CONTACT_DOCUMENTS",
  DELETE_CONTACT_DOCUMENTS = "DELETE_CONTACT_DOCUMENTS",
  READ_COMMENTS = "READ_COMMENTS",
  WRITE_COMMENTS = "WRITE_COMMENTS",
  VIEW_DASHBOARDS = "VIEW_DASHBOARDS"
}

export interface RoleEntity {
  id: string;
  name: string;
  permissions: Permission[];
}

export interface JwtResponse {
  token: string;
  id: string;
  username: string;
  emailSignature: string | null;
  roles: Role[];
  userConfig: UserConfig;
  avatarSmall?: string | null;
  email:  string | null;
  phoneNumber: string | null;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface ChangePasswordRequest {
  password: string;
}

export interface AuditData {
  createdBy: string;
  createdOn: Date | null;
  lastModifiedBy: string;
  lastModifiedOn: Date | null;
  deletedOn: Date | null;
}

interface AuthApi {
  signin(login: LoginRequest): Promise<JwtResponse>;
  logout(): Promise<void>;
  changePassword(changePasswordRequest: ChangePasswordRequest): Promise<void>;
  listRoles(): Promise<RoleEntity[]>;
  addRole(role: RoleEntity): Promise<void>;
  editRole(role: RoleEntity): Promise<void>;
  deleteRole(role: RoleEntity): Promise<void>;
}

export const authApi: AuthApi = {
  async signin(login) {
    return (await axios.post(`/api/auth/signin`, login)).data;
  },

  async logout() {
    return await axios.post(`/logout`);
  },

  async changePassword(changePasswordRequest) {
    return await axios.post(`/api/auth/changepassword`, changePasswordRequest);
  },

  async listRoles() {
    return (await axios.get(`/api/roles`)).data;
  },
  async addRole(role) {
    return await axios.post(`/api/roles`, role);
  },
  async editRole(role) {
    return await axios.put(`/api/roles/${role.id}`, role);
  },
  async deleteRole(role) {
    return await axios.delete(`/api/roles/${role.id}`);
  },
};
